import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'materialtype'
})
export class MaterialtypePipe implements PipeTransform {
  private types: any;

  constructor(){
    this.types = {
      ppt: ['PPT', 'fa-file-powerpoint'],
      doc: ['DOC', 'fa-file-word'],
      pdf: ['PDF', 'fa-file-pdf'],
      img: ['IMG', 'fa-file-image']
    }
  }

  transform(value: any, args?: any): any {
    if(!this.types[value]){
      return 'Unknown';
    }

    return args === 'icon' ? this.types[value][1] : this.types[value][0];
  }

}
